import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}" />;
}
